module.exports = __webpack_public_path__ + "img/car-park-control-1.5dbcb0bc.webp";